import React, { useEffect, useState } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import "./hidescrollbar.css";
import Button from "@material-ui/core/Button";
import { Typography } from "@material-ui/core";
import { fontSize } from "../../styles";
import { useWindowDimensions } from "./window-dimensions";

const useStyles = makeStyles((theme) => ({
  right: {
    display: "flex",
    flexDirection: "row",
    width: "90%",
    [theme.breakpoints.only("sm")]: {
      width: "85%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      marginTop: 5,
    },
  },
  left: {
    minWidth: 90,
    fontSize: fontSize.h4,
    marginLeft: 10,
    textAlign: "left",
    cursor: "context-menu",
    [theme.breakpoints.down("xs")]: {
      cursor: "pointer",
    },
  },
  scrollbar: {
    marginTop: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 57,
    marginBottom: 10,
    maxWidth: "95vw",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      marginBottom: 40,
    },
  },
  gridList: {
    overflowX: "auto",
    scrollbarWidth: "none",
    display: "flex",
    flexDirection: "row",
  },
  listItem: { paddingLeft: 5, paddingRight: 5 },
  singleButton: {
    border: "none",
    height: 50,
    color: "#FFFFFF",
    background: "#457B9D",
    textTransform: "none",
    fontSize: fontSize.h6,
    lineHeight: 1.5,
    [theme.breakpoints.down("xs")]: {
      height: 35,
      fontSize: fontSize.h6,
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "inline-block",
      minWidth: "15vw",
    },
    [theme.breakpoints.up("sm")]: {
      width: 200,
    },

    [theme.breakpoints.only("sm")]: {
      fontSize: 13,
    },
  },
  phoneFocusDiv: {
    margin: "auto",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
  },
  phoneFocusButton: {
    border: "none",
    height: 60,
    color: "#FFFFFF",
    backgroundColor: "#1D3557",
    textTransform: "none",
    opacity: 1.0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  focusedTitle: {
    marginLeft: 5,
    marginRight: 5,
    textAlign: "center",
    fontSize: fontSize.h6,
  },
}));

const CategoryHorizontalScroll = ({
  title,
  options,
  defaultValue,
  setParentState,
}) => {
  const id = "listview";
  const classes = useStyles();
  const isFirefox = window.navigator.userAgent.indexOf("Firefox") !== -1;
  const theme = useTheme();
  const isWidthSm = useMediaQuery(theme.breakpoints.down("xs"));

  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [hideFocusOption, setHideFocusOption] = useState(false);

  const { width } = useWindowDimensions();

  // eg. [A,B,C,Z] --> [Z',A,B,C,Z,A']
  // Z' --> pseudoLast || A' --> pseudoFirst
  const carousel = (option) => {
    let temp = [...option];
    if (isWidthSm && option.length !== 0) {
      let tempFirstItem = { id: "pseudoFirst", name: option[0].name };
      let tempLastItem = {
        id: "pseudoLast",
        name: option[option.length - 1].name,
      };
      temp.unshift(tempLastItem);
      temp.push(tempFirstItem);
    }
    return temp;
  };

  //if mobile view, make it carousel array type; else remain the same
  const updatedOptions = isWidthSm ? carousel(options) : options;

  const updateChosen = (chosenNode) => {
    let scroller = document.getElementById(id);
    setSelectedOption(chosenNode.name);
    setParentState(chosenNode);
    if (isWidthSm) {
      //determine the distance to be scrolled
      let total = 0;
      if (
        updatedOptions &&
        scroller &&
        document.getElementById(updatedOptions[0].id)
      ) {
        for (let i = 0; i < updatedOptions.length; i++) {
          if (updatedOptions[i + 1] === chosenNode) {
            //leave some space at the left side for scrolling/dragging
            total +=
              document.getElementById(updatedOptions[i].id).clientWidth / 1.5;
            break;
          }
          //this element can be completely hidden
          else {
            total += document.getElementById(updatedOptions[i].id).clientWidth;
          }
        }
        setTimeout(() => {
          scroller.scrollTo(total, 0);
        }, 50);
        if (!isFirefox) scroller.style.scrollBehavior = "smooth"; //make scroller back to sliding
      }
    } else scrollToView(chosenNode.id);
  };

  const scrollToView = (optionId) => {
    let element = document.getElementById(optionId);
    if (element !== null)
      element.scrollIntoView({
        behavior: "auto",
        inline: "center",
        block: "nearest",
      });
  };

  //slide a little and instant jump
  const fakeScroll = (direction, chosenNode) => {
    let scroller = document.getElementById(id);
    scroller.scrollBy(direction === "right" ? 50 : -50, 0); //slide

    setTimeout(() => {
      scroller.style.scrollBehavior = "auto"; //jump
      updateChosen(chosenNode);
    }, 80); //time spare for sliding before instant jump
  };

  //for normal behavior, slide as usual
  const smoothScroll = (chosenNode) => {
    if (!isFirefox) document.getElementById(id).style.scrollBehavior = "smooth";
    updateChosen(chosenNode);
  };

  const clickBack = (id) => {
    if (isWidthSm) {
      if (selectedOption !== options[0].name) {
        for (let i = 0; i < options.length; i++) {
          if (options[i].name === selectedOption) {
            smoothScroll(options[i - 1]);
            break;
          }
        }
      } else {
        fakeScroll("left", options[options.length - 1]);
      }
    } else document.getElementById(id).scrollLeft -= 300;
  };

  const clickNext = (id) => {
    if (isWidthSm) {
      if (selectedOption !== options[options.length - 1].name) {
        for (let i = 0; i < options.length; i++) {
          if (options[i].name === selectedOption) {
            smoothScroll(options[i + 1]);
            break;
          }
        }
      } else {
        fakeScroll("right", options[0]);
      }
    } else document.getElementById(id).scrollLeft += 300;
  };

  useEffect(() => {
    for (let i = 0; i < options.length; i++) {
      if (selectedOption === options[i].name) {
        scrollToView(options[i].id);
        break;
      }
    }
  }, [selectedOption, width, options]);

  const handleClick = (option) => {
    if (option.id.toString().includes("pseudo")) {
      if (option.id === "pseudoLast") {
        //scroll to the actual last element
        fakeScroll("left", options[options.length - 1]);
      } else {
        //scroll to the actual first element
        fakeScroll("right", options[0]);
      }
    } else {
      smoothScroll(option);
    }
  };

  // mobile
  const handleScroll = () => {
    setHideFocusOption(true);
    setTimeout(() => {
      setHideFocusOption(false);
    }, 400);
  };

  const checkDragging = () => {
    let scroller = document.getElementById(id);
    let scrollLeft = document.getElementById(id).scrollLeft; //magnitude of scrolled distance to the right

    let passingDistance = scrollLeft + scroller.offsetWidth;

    let firstElementWidth = document.getElementById(updatedOptions[0].id)
      .offsetWidth;
    let lastElementWidth = document.getElementById(
      updatedOptions[updatedOptions.length - 1].id
    ).offsetWidth;

    //when first element is selected and user scrolls to the left
    if (scrollLeft < firstElementWidth / 2.5) {
      //scroll to the last
      fakeScroll("left", options[options.length - 1]);
    } else {
      //normal dragging behavior
      if (passingDistance < scroller.scrollWidth - lastElementWidth / 3) {
        //chosenIndex: the element desired by user
        let chosenIndex = 0,
          totalWidth = 0,
          maxWidth = scrollLeft + scroller.offsetWidth / 2.5;
        for (let i = 0; i < updatedOptions.length; i++) {
          totalWidth += document.getElementById(updatedOptions[i].id)
            .clientWidth;
          if (totalWidth > maxWidth) {
            chosenIndex = i;
            break;
          }
        }
        if (chosenIndex === updatedOptions.length - 1) {
          //if accidentally caught pseudoFirst
          fakeScroll("right", options[0]);
        } else {
          if (chosenIndex === 0) {
            //if accidentally caught pseudoLast
            fakeScroll("left", options[options.length - 1]);
          } else {
            //normal behavior
            smoothScroll(updatedOptions[chosenIndex]);
          }
        }
      } else {
        //when the last element is selected and user scrolls to the right
        fakeScroll("right", options[0]);
      }
    }
  };

  //render options of the horizontal list
  return (
    <div className={`hideScrollbar ${classes.scrollbar}`}>
      <Typography variant="h3" className={classes.left}>
        {title}
      </Typography>
      <div className={classes.right}>
        <IconButton
          color="primary"
          aria-label="back"
          onClick={() => clickBack(id)}
          size={!!isWidthSm ? "small" : "normal"}
        >
          <KeyboardArrowLeftIcon />
        </IconButton>
        {isWidthSm ? ( //phone view
          <>
            <List //horizontal list here
              id={id}
              className={`hideScrollbar ${classes.gridList}`}
              style={!isFirefox ? { scrollBehavior: "smooth" } : null}
              onScroll={() => handleScroll()}
              onTouchEnd={() => checkDragging()}
            >
              {updatedOptions.map((option) => (
                <>
                  <ListItem key={option.name} className={classes.listItem}>
                    <Button
                      variant="contained"
                      id={option.id}
                      value={option.id}
                      className={classes.singleButton}
                      style={{
                        minWidth: width / 3,
                        opacity: hideFocusOption ? 1.0 : 0.6,
                        backgroundColor: "#457B9D",
                      }}
                      onClick={() => {
                        handleClick(option);
                      }}
                    >
                      {option.name}
                    </Button>
                  </ListItem>
                </>
              ))}
            </List>
            <div //the dark blue div that covers the list
              id={id.toString() + "Mobile"}
              className={classes.phoneFocusDiv}
              style={{
                left: width / 2,
                right: width / 2,
                opacity: hideFocusOption ? 0 : 1,
              }}
            >
              <div className={classes.phoneFocusButton}>
                <div
                  className={classes.focusedTitle}
                  style={{ width: width / 2.5 }}
                >
                  {selectedOption}
                </div>
              </div>
            </div>
          </>
        ) : (
          //desktop view
          <List
            id={id}
            className={`hideScrollbar ${classes.gridList}`}
            style={{ scrollBehavior: "smooth" }}
          >
            {options.map((option, index) => (
              <ListItem key={option.name} className={classes.listItem}>
                <Button
                  variant="contained"
                  id={option.id}
                  value={option.id}
                  className={classes.singleButton}
                  style={{
                    backgroundColor:
                      option.name === selectedOption ? "#1D3557" : "#457B9D",
                    borderRadius:
                      index === 0
                        ? options.length === 1
                          ? "20px"
                          : "20px 0px 0px 20px"
                        : index === options.length - 1
                        ? "0px 20px 20px 0px"
                        : 0,
                  }}
                  onClick={() => handleClick(option)}
                >
                  {option.name}
                </Button>
              </ListItem>
            ))}
          </List>
        )}
        <IconButton
          color="primary"
          aria-label="back"
          onClick={() => {
            clickNext(id);
          }}
          size={!!isWidthSm ? "small" : "normal"}
        >
          <KeyboardArrowRightIcon />
        </IconButton>
      </div>
    </div>
  );
};

export default CategoryHorizontalScroll;
